<div class="flex flex-col p-6 pb-12 items-center text-center bg-white rounded-2xl shadow">
    <img [src]="assetUrl + 'icons/' + data[mode].icon + '.svg'" 
         [alt]="data[mode].icon"
         class="pb-4 pt-6"
    >
    <span class="text-md text-gray-900 pb-1">{{ data[mode].title }}</span>
    <span class="text-sm text-gray-600 pb-6">{{ data[mode].desc }}</span>
    @if (showBtn && data[mode].buttonTitle) {
        <button class="ml-3 px-6 py-2 shadow rounded-3xl bg-gray-950 text-xs md:text-md text-white whitespace-nowrap">
            {{data[mode].buttonTitle}}
        </button>
    }
</div>